// Fire-and-forget increment of a global all-time game counter
// (see api/count.js). Page views are tracked natively by Vercel Analytics.
// key: 'games-played' | 'games-human' | 'games-ai' | 'games-draws'
export function incrementCounter(key) {
  try {
    fetch('/api/count', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key }),
      keepalive: true,
    });
  } catch {
    // telemetry must never break gameplay
  }
}
